import { roFocusedStageId } from "./roFocusedWorkflow";

export type RoLiveWorkStage = "diagnosis" | "repair";

export type RoLiveWorkPresentation = {
  active: boolean;
  stageId: RoLiveWorkStage | null;
  label: "Diagnosis in progress" | "Repair in progress" | null;
};

/**
 * A running timer is the only signal that work is actively happening.
 * Wording matches the focused-workflow next action: diagnosis/intake timers
 * are diagnosis; every other running timer is repair.
 */
export function roLiveWorkPresentation(
  status: string | null | undefined,
  timerRunning: boolean,
): RoLiveWorkPresentation {
  if (!timerRunning) return { active: false, stageId: null, label: null };
  const stageId = roFocusedStageId(status);
  if (stageId === "diagnosis" || stageId === "intake") {
    return { active: true, stageId: "diagnosis", label: "Diagnosis in progress" };
  }
  return { active: true, stageId: "repair", label: "Repair in progress" };
}
